@if (editBetState$ | async; as editBetState) {
    <bs-digital-pick-list>
        @for (pick of editBetState.picks.pickList; track pickTrackBy($index, pick)) {
            <div [ngClass]="{ 'highlight-new-pick': getPickUi(pick).highlightPick, 'edit-bet__picks-item': true }">
                @if (oddsDisplayFormat$ | async; as oddsDisplayFormat) {
                    <bs-edit-bet-pick
                        [pick]="pick"
                        [pickState]="editBetState.picks.pickState[pick.id.toString()]"
                        [oddsDisplayFormat]="oddsDisplayFormat"
                        [pickUiState]="getPickUi(pick)"
                        [msAutomation]="pick.id.toString()" />
                }
            </div>
        }
    </bs-digital-pick-list>
}
